import Tooltip, { ContentAnnounced } from './Tooltip';

export {
  ContentAnnounced,
};

export default Tooltip;
